<template>
  <div>
    <span class="span-title">{{ $t('daily_summary.invoice_state') }}</span>
      <select
          id="invoiceState"
          v-model="selectedInvoiceState"
          class="form-select form-select-sm"
      >
          <option :value="null">
              {{ $t('daily_summary.select_invoice_state') }}
          </option>
          <option
              v-for="option in invoiceStateOptions"
              :key="option.value"
              :value="option.value"
          >
              {{ option.text }}
          </option>
      </select>
  </div>
</template>

<script>
export default {
    name: "InvoiceStateFilter.vue",
    props: {
        modelValue: {
            type: Object,
            default: null
        },
        invoiceStateOptions: {
            type: Array,
            default() {
                return []
            }
        },
    },
    data: function () {
        return {
            loading: false,
            selectedInvoiceState: null
        }
    },
    watch: {
        selectedInvoiceState: function (){
            let invoiceState = this.invoiceStateOptions.find(item => item.value === this.selectedInvoiceState)
            this.$emit('update:modelValue', invoiceState)
        }
    },
}
</script>
